import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Loader } from '../../../component/loader';
import { useGetAllLifestyleServicesQuery } from '../../../store/lifeStyle/api';
import { ILifeStyleService } from '../../../store/lifeStyle/interface';
import { AddService } from './serviceComponent/addService';
import { ServiceListCard } from './serviceComponent/serviceListCard';
import { AddStoreBtn, Container, Header, ListContainer, Title } from './styles';

export const AllServices = () => {
  const { state } = useLocation();
  const [categoryId] = useState((state as { categoryId: string }).categoryId);
  const [categoryName] = useState(
    (state as { categoryName: string }).categoryName
  );
  const [addServiceModal, setAddServiceModal] = useState(false);
  const { data: allLifestyleServices, isLoading: isServiceLoading } =
    useGetAllLifestyleServicesQuery(categoryId);
  const [allServices, setAllServices] = useState<ILifeStyleService[]>([]);
  const handleAddCategory = () => {
    setAddServiceModal(true);
  };
  useEffect(() => {
    setAllServices(allLifestyleServices?.data?.fetchedData ?? []);
  }, [allLifestyleServices]);

  return (
    <Container>
      {isServiceLoading && <Loader />}
      {addServiceModal && <AddService setShow={setAddServiceModal} />}
      <Header>
        <Title>{categoryName}</Title>
        <AddStoreBtn onClick={() => handleAddCategory()}>
          Add Services
        </AddStoreBtn>
      </Header>
      <ListContainer>
        {allServices?.map((item, index) => (
          <ServiceListCard
            // handleDelete={() => handleDeleteProperty(item._id)}
            services={item}
            key={index.toString()}
          />
        ))}
      </ListContainer>
    </Container>
  );
};
